import { useGpsDeviceStats } from './use-gps-device-stats';
import { useGpsTripsStats } from './use-gps-trips-stats';
import { useGpsAlertStats } from './use-gps-alert-stats';

/**
 * Hook agregador para estatísticas GPS do Dashboard FleetONE
 * Combina métricas de dispositivos, viagens e alertas GPS
 */
export interface GpsDashboardStats {
  // Dispositivos
  online: number;
  total: number;
  
  // Viagens
  tripsToday: number;
  percentChange: number;
  
  // Alertas
  activeAlerts: number;
  
  // Quilometragem
  kmToday: number;
  
  // Loading states
  isLoading: boolean;
}

export function useGpsStats(companyId?: string): GpsDashboardStats {
  const { data: deviceStats, isLoading: loadingDevices } = useGpsDeviceStats(companyId);
  const { data: tripsStats, isLoading: loadingTrips } = useGpsTripsStats(companyId);
  const { data: alertStats, isLoading: loadingAlerts } = useGpsAlertStats(companyId);
  
  return {
    // Dispositivos
    online: deviceStats?.online || 0,
    total: deviceStats?.total || 0,
    
    // Viagens
    tripsToday: tripsStats?.today || 0,
    percentChange: tripsStats?.percentChange || 0,
    
    // Alertas
    activeAlerts: alertStats?.unresolved || 0,
    
    // Quilometragem
    kmToday: tripsStats?.totalDistanceKm || 0,
    
    // Loading
    isLoading: loadingDevices || loadingTrips || loadingAlerts
  };
}
